import(/* webpackMode: "eager", webpackExports: ["HtmlLangSync"] */ "/vercel/path0/components/i18n/HtmlLangSync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/vercel/path0/components/landing/faq.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PublicFooter"] */ "/vercel/path0/components/landing/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobeSectionLazy"] */ "/vercel/path0/components/landing/globe-lazy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LandingHero"] */ "/vercel/path0/components/landing/hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LandingMotionConfig"] */ "/vercel/path0/components/landing/motion-config.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LandingNav"] */ "/vercel/path0/components/landing/navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PricingSection"] */ "/vercel/path0/components/landing/pricing.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SecuritySection"] */ "/vercel/path0/components/landing/security.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StackedFeatures"] */ "/vercel/path0/components/landing/stacked-features.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Testimonials"] */ "/vercel/path0/components/landing/testimonials.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WhyGrid"] */ "/vercel/path0/components/landing/why-grid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WorkflowSteps"] */ "/vercel/path0/components/landing/workflow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/next-intl@4.14.2_next@15.2.8_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1__react@18.3.1/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.2.8_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/script.js");
